import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="bg-white py-20 px-4" data-id="element-163">
      <div className="max-w-[720px] mx-auto" data-id="element-164">
        <FadeIn data-id="element-165">
          <div className="mb-12 border-l-4 border-[#4A7C42] pl-6 py-2" data-id="element-166">
            <p className="text-xl md:text-2xl text-[#1A1A1A] italic leading-relaxed font-medium" data-id="element-167">
              "Son las 7 de la mañana. Abres el armario, eliges tu pantalón
              favorito y, al intentar cerrarlo, sientes ese nudo de frustración
              en el estómago. No es que hayas ganado peso de la noche a la
              mañana. Es esa inflamación persistente que hace que te sientas
              pesada, cansada y con el abdomen rígido antes de que termine el
              café."
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-168">
          <p className="text-lg text-[#5A5A5A] mb-12 leading-relaxed" data-id="element-169">
            Has probado a comer "sano", a tomar jugos verdes y a matarte en el
            gimnasio, pero al final del día, tu cuerpo parece tener vida propia.
            Sientes que tu ropa te traiciona y tu energía se agota antes de las
            3 de la tarde.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-170">
          <h2 className="text-3xl font-bold text-[#1A1A1A] mb-6" data-id="element-171">
            Lo que la mayoría de los "expertos" no te dicen
          </h2>
          <div className="space-y-6 text-lg text-[#5A5A5A] leading-relaxed" data-id="element-172">
            <p data-id="element-173">
              Lo que la mayoría de los "expertos" no te dicen es que la
              hinchazón abdominal no se soluciona con déficit calórico. Lo que
              experimentas es una respuesta inmune de tu cuerpo ante irritantes
              que crees que son saludables.
            </p>
            <p data-id="element-174">
              Cuando tu sistema digestivo está en alerta roja, recluta agua para
              diluir toxinas. El resultado es esa sensación de pesadez, neblina
              mental y un abdomen que se expande como un globo a medida que
              pasan las horas. Seguir una dieta tradicional en este estado solo
              eleva tu cortisol y empeora la retención de líquidos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}